import Showcase from "./Showcase";
import BadgeHolder from "./BadgeHolder";


export default function RR1() {
    const style = { backgroundImage: `url('/img/rr1blur.jpg')` }

    let imageFirst = true;
    function alternateImagePosition() {
        imageFirst = !imageFirst;
        return imageFirst;
    }

    return (
        <>
            <header className="masthead" style={style}>
                <div className="container position-relative px-5">
                    <div className="row justify-content-center">
                        <div className="col-xl-6">
                            <div className="text-center text-white">
                                <h1 className="mb-5">RFID/NFC čitač</h1>
                                <h2>Uređaj i API za čitanje RFID kartica</h2>
                                <p>Jednostavno dodajte mogućnost čitanja i pisanja RFID kartica u svoju aplikaciju, pozivom nekoliko JSON komandi.</p>
                            </div>
                        </div>
                    </div>
                </div>


            </header>
            <Showcase naslov="Jednostavan i kompaktan uređaj" opis="Ovaj pametni RFID čitač pruža jednostavno, pouzdano i brzo upravljanje beskontaktnim karticama i privjescima. Dizajniran za besprijekornu integraciju u vaše postojeće sustave, uređaj omogućuje trenutno prepoznavanje korisnika, sigurno čitanje i zapisivanje podataka te potpunu kontrolu pristupa u realnom vremenu." pictureFirst={alternateImagePosition()} image="rr1b.jpg" />

            <Showcase naslov="Sigurnost na prvom mjestu" opis="Omogućuje potpunu zaštitu i izmjenu sigurnosnih ključeva za bezbrižno korištenje" pictureFirst={alternateImagePosition()} image="rfid-key.jpg" />

            <Showcase naslov="Trenutna detekcija" opis="Automatski prepoznaje karticu čim se primakne uređaju za maksimalnu brzinu rada." pictureFirst={alternateImagePosition()} image="rfid-tag.jpg" />

            <Showcase naslov="Jednostavna integracija" opis={'Lako se povezuje i komunicira s vašim aplikacijama putem JSON poruka. \nSlanjem komande {"command":"read", "block":0}, uređaj vraća npr. {"status":0, "rfid":"A1B2C3D4", "data":"A1B2C3D4....."}. Tu su i ostale komande koje omogućavaju pisanje i čitanje ostalih sektora kartice.'} pictureFirst={alternateImagePosition()} image="rr1.jpg" />

            <Showcase naslov="Potpuna kontrola" opis="Nudi napredne opcije pregleda, čitanja i izmjene sadržaja na karticama " pictureFirst={alternateImagePosition()} image="rfid-control.jpg" />

            <BadgeHolder skip="RFID/NFC čitač kartica" />

        </>

    )
}